export default {
  fontFamilyBase: '"Source Sans Pro", sans-serif',
  fontFamilyBaseItalic: '"Source Sans Pro Italic", sans-serif',
  fontFamilyHeader: '"Brandon Grotesque", sans-serif',
  fontFamilyHeaderBold: '"Brandon Grotesque Bold", sans-serif',
  fontFamilyHeaderLight: '"Brandon Grotesque Light", sans-serif',
  fontSize: '16px',
  lineHeight: '28px',
};
